import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'
import { BiSearch } from 'react-icons/bi'

interface SearchBarProps {
  onSearch: (query: string) => void
}

const SearchBar: FC<SearchBarProps> = ({ onSearch }) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(value)
    }, 300)

    return () => clearTimeout(timer)
  }, [value, onSearch])

  return (
    <InputGroup size="lg">
      <InputLeftElement pointerEvents="none">
        <BiSearch color="#A0AEC0" size="20px" />
      </InputLeftElement>
      <Input
        placeholder="Buscar artigos, tutoriais, dúvidas..."
        value={value}
        onChange={e => setValue(e.target.value)}
        bg="white"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="8px"
        _focus={{ borderColor: 'green.500', boxShadow: '0 0 0 1px #38A169' }}
        _placeholder={{ color: 'gray.400' }}
      />
    </InputGroup>
  )
}

export default SearchBar
